module.exports = __webpack_public_path__ + "static/media/icon-flip-door-back-to-front.66c8e7d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-flip-door-back-to-front.svg
// module id = 955
// module chunks = 0